import { Mail, Phone, ShieldCheck, UserRound } from 'lucide-react';
import PageHeader from '../../components/PageHeader';
import Avatar from '../../components/Avatar';
import { useAuth } from '../../context/AuthContext';
import styles from './Profile.module.css';

export default function Profile() {
  const { user } = useAuth();

  const fields = [
    { icon: UserRound, label: 'Name', value: user?.name || '—' },
    { icon: Mail, label: 'Email', value: user?.email || '—' },
    { icon: Phone, label: 'Phone', value: user?.phone || '—' },
    {
      icon: ShieldCheck,
      label: 'Roles',
      value: user?.groups?.length ? user.groups.join(', ') : '—',
    },
  ];

  return (
    <div>
      <PageHeader
        eyebrow="Account"
        title="Your profile"
        subtitle="Details from your signed-in staff account."
      />

      <section className={styles.card}>
        <div className={styles.hero}>
          <Avatar name={user?.name || 'Staff'} size={64} />
          <div>
            <h2 className={styles.name}>{user?.name || 'Store Staff'}</h2>
            <p className={styles.email}>{user?.email || 'No email on file'}</p>
          </div>
        </div>

        <dl className={styles.fields}>
          {fields.map(({ icon: Icon, label, value }) => (
            <div key={label} className={styles.field}>
              <dt className={styles.label}>
                <Icon size={14} /> {label}
              </dt>
              <dd className={styles.value}>{value}</dd>
            </div>
          ))}
        </dl>
      </section>
    </div>
  );
}
